"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useWhyDidYouUpdate = useWhyDidYouUpdate;
var _react = require("react");
function useWhyDidYouUpdate(name, props) {
  // Get a mutable ref object where we can store props ...
  // ... for comparison next time this hook runs.
  const previousProps = (0, _react.useRef)();
  const changesObj = {};
  (0, _react.useEffect)(() => {
    if (process.env.NODE_ENV === 'production') {
      return;
    }
    if (previousProps.current) {
      const previousPropsObj = typeof previousProps.current === 'object' ? previousProps.current : {};

      // Get all keys from previous and current props
      const allKeys = Object.keys({
        ...previousPropsObj,
        ...props
      });
      // Use this object to keep track of changed props
      // Iterate through keys
      allKeys.forEach(key => {
        // If previous is different from current
        if (previousPropsObj[key] !== props[key]) {
          // Add to changesObj
          changesObj[key] = {
            from: previousPropsObj[key],
            to: props[key]
          };
        }
      });
      // If changesObj not empty then output to console
      if (Object.keys(changesObj).length) {
        console.info('[why-did-you-update]', name, changesObj);
      }
    }
    // Finally update previousProps with current props for next hook call
    previousProps.current = props;
  });
  return changesObj;
}